const ApiUrl = '555'

export default {
    ApiUrl
}


//////////////////
// WEBPACK FOOTER
// ./configure.js
// module id = null
// module chunks = 